const RolesHelper = {
  ROL_SUPER_ADM_MDIRECTOR: 'admin_mdirector',
  ROL_SUPER_ADM_MDIRECTOR_REPORTS: 'admin_mdirector_reports',
  ROL_SUPER_ADM_MDIRECTOR_SA: 'admin_mdirector_sa',
  ROL_ADM_MDIRECTOR_NEWFREE: 'adm_mdirector_newfree',
  ROL_ADM_MDIRECTOR: 'adm_mdirector',
  ROL_ANALYST_MDIRECTOR: 'analyst_mdirector',
  ROL_CPM_MDIRECTOR: 'cpm_mdirector',
  ROL_CPM_REPORT_MDIRECTOR: 'cpm_report_mdirector',
  ROL_CPU_MDIRECTOR: 'cpu_mdirector',
  ROL_DB_MDIRECTOR: 'db_mdirector',
  ROL_GCYC_MDIRECTOR: 'gcyc_mdirector',
  ROL_NDC_MDIRECTOR: 'ndc_mdirector',
  ROL_REPORT_MDIRECTOR: 'report_mdirector',
  ROL_STD_MDIRECTOR: 'std_mdirector',
  ROL_UC_MDIRECTOR: 'uc_mdirector',
};

export default RolesHelper;
